import React, { memo } from "react";
import cn from "classnames";
import s from "./style.module.css";
import MuteCheckBox from "../MuteCheckBox";
import { FocusOn } from "react-focus-on";

const Plane = ({ message = "tr", color = "currentColor", delay = 0 }) => {
  return (
    <div className={s.fly}>
      <svg
        style={{ "--delay": delay }}
        width="111"
        height="64"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none">
          <g transform="translate(39.15 16)">
            <path
              d="M.45 15.9l4.7-2.5c1.8-1 3.9-1.5 5.9-1.5h43.5l1.2-.3c1.2-.3 2.3-.9 3.1-1.9l7-8.4c.3-.4.8-.6 1.3-.6h2.5c.2 0 .3.2.2.3l-2.9 11.5 3.9.7c.1 0 .1.1.1.1v1.1c0 .1 0 .1-.1.1l-11.3 3.1c-4.5 1.2-9.1 1.8-13.8 1.8h-30.7c-4.7 0-9.3-.5-13.9-1.4-.6-.1-1.1-.7-1.1-1.4-.1-.2.1-.5.4-.7z"
              fill="#FFF"
            />
            <path
              d="M45.95 19.5h-30.9c-4.7 0-9.3-.5-13.9-1.4-.6-.1-1.1-.7-1.1-1.4 0-.3.2-.6.5-.8l4.7-2.5c1.8-1 3.9-1.5 5.9-1.5h.3v.1c1.8 3.4 5.3 5.5 9.1 5.5h39.7l-.7.2c-4.4 1.1-9 1.8-13.6 1.8zm15.5-5.6l7.3-1.5h3l-3.7 1.8c-.1.1-.3.1-.4.1h-6.2-.1c-.1-.2 0-.4.1-.4z"
              fill={color}
            />
            <path
              d="M58.95 9.8l3.2-3.8-.6 1.5c-.8 1.9.1 4.2 2.1 4.9h-.6l-8.4-.4 1.2-.3c1.2-.3 2.3-1 3.1-1.9z"
              fill="#145569"
            />
            <path
              fill="#071920"
              opacity=".4"
              d="M5.45 14.8L2.65 14.8 4.65 13.7 7.15 13.7z"
            />
            <path
              d="M9.45 12.8c.5 0 .9.4.9.9v1.9c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-1.9c-.1-.5.3-.9.9-.9z"
              fill="#071920"
              opacity=".4"
            />
            <path
              d="M56.65 12.8c.5 0 .9.4.9.9v1.9c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-1.9c0-.5.4-.9.9-.9zm-29.2.9c.3 0 .6.3.6.6v.8c0 .3-.3.6-.6.6s-.6-.3-.6-.6v-.8c0-.4.2-.6.6-.6zm1.5 0c.3 0 .6.3.6.6v.8c0 .3-.3.6-.6.6s-.6-.3-.6-.6v-.8c.1-.4.3-.6.6-.6z"
              fill="#145569"
              opacity=".1"
            />
            <path
              d="M12.55 14.1c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2z"
              fill="#071920"
            />
            <path
              d="M13.35 14.4c0-.2.1-.3.2-.3s.2.1.2.2v.2c0 .1 0 .1-.1.2l-.3-.3z"
              fill="#145569"
              opacity=".1"
            />
            <path
              d="M13.35 14.6v-.1l.3.3h-.1c-.1 0-.2-.1-.2-.2z"
              fill="#071920"
            />
            <path
              d="M14.55 14.1c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1.1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1 0-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1.1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c-.1-.1 0-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1.1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1 0-.2.2-.2zm1.6 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1 0-.2.2-.2zm1.5 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1.7 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1 0-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1.1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c-.1-.1 0-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1.1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1 0-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1.1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c-.1-.1 0-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1.1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1 0-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c0-.1.1-.2.2-.2zm1.1 0c.1 0 .2.1.2.2v.2c0 .1-.1.2-.2.2s-.2-.1-.2-.2v-.2c-.1-.1 0-.2.2-.2z"
              fill="#145569"
              opacity=".1"
            />
            <path
              d="M38.85 14.6c1.2-.2 2.2-.8 2.9-1.8l2.8-3.6c.2-.2.4-.3.6-.3h.6c.1 0 .1.1.1.1l-2.2 4.5c-.2.5-.7.9-1.2 1l-3.6.1z"
              fill={color}
            />
            <path
              d="M22.95 17.4l15.9-2.8h3.7l-10.5 3.7c-1 .4-2.1.5-3.2.5l-6.1-.2c-.4 0-.6-.5-.4-.8.1-.2.4-.4.6-.4z"
              fill="#071920"
            />
            <path
              d="M29.65 20.3h-1.7v-2.9h6.9c.1 0 .1.1 0 .1l-1.8 1.5c-.9.8-2.1 1.3-3.4 1.3z"
              fill="#145569"
            />
            <path
              d="M25.65 20.7h-2.2v-3.8h9.1c.1 0 .1.1.1.2l-2.4 2c-1.4 1-3 1.6-4.6 1.6z"
              fill="#FFF"
            />
            <path
              d="M22.35 18.8c0-1.1.5-1.9 1.1-1.9.6 0 1.1.8 1.1 1.9 0 1.1-.5 1.9-1.1 1.9-.7 0-1.1-.8-1.1-1.9z"
              fill="#145569"
            />
            <path
              d="M23.35 18.3c.2 0 .3.2.3.5s-.1.5-.3.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5z"
              fill="#FFF"
            />
            <path
              d="M71.05 13.2l-.5-.1v1.6l.5-.1c.1 0 .1-.1.1-.1v-1.1c0-.1-.1-.2-.1-.2z"
              fill="#145569"
            />
          </g>
          {message === "bl" && (
            <path
              className={s.message}
              d="M44.9 44.183H11c-1.1 0-2 .9-2 2v15.4c0 1.1.9 2 2 2h35.4c1.1 0 2-.9 2-2v-20.3c0-.2-.3-.4-.4-.2l-3.1 3.1z"
              fill="#145569"
            />
          )}
          {message === "br" && (
            <path
              className={s.message}
              d="M51.4 44.266h33.9c1.1 0 2 .9 2 2v15.4c0 1.1-.9 2-2 2H49.9c-1.1 0-2-.9-2-2v-20.3c0-.2.3-.4.4-.2l3.1 3.1z"
              fill="#145569"
            />
          )}
          {message === "tr" && (
            <path
              className={s.message}
              d="M96.4 0H51c-1.1 0-2 .9-2 2v20.2c0 .2.3.4.4.2l3.1-3.1h43.8c1.1 0 2-.9 2-2V2c.1-1.2-.8-2-1.9-2z"
              fill="#145569"
            />
          )}

          {message === "tl" && (
            <path
              className={s.message}
              d="M1.908 0h45.4c1.1 0 2 .9 2 2v20.2c0 .2-.3.4-.4.2l-3.1-3.1h-43.8c-1.1 0-2-.9-2-2V2c-.1-1.2.8-2 1.9-2z"
              fill="#145569"
            />
          )}
        </g>
      </svg>
    </div>
  );
};

const HomeScreen = ({ hide, isHidden, hasLoaded, loadedPercentage }) => {
  return (
    <FocusOn enabled={!isHidden}>
      <div className={cn(s.wrap, { [s.isHidden]: isHidden })}>
        <div className={s.container}>
          <div className={s.inner}>
            <div className={s.titleTower}>
              <h1 className={s.title}>
                Plane
                <br />
                talking
              </h1>

              <div className={s.animation}>
                <svg viewBox="0 0 115 177" xmlns="http://www.w3.org/2000/svg">
                  <g fill="none">
                    <g
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      transform="translate(19 29)"
                      fill="#071920"
                      stroke="#145569"
                    >
                      <path d="M32.0509091 146.942044L32.0509091 70.535011 46.1618182 70.535011 46.1618182 146.942044" />
                      <path d="M51.764 53.273H26.378a1.904 1.904 0 0 1-1.914-1.91v-13.16c0-1.06.85-1.91 1.914-1.91h25.386c1.063 0 1.914.85 1.914 1.91v13.16c.071 1.06-.85 1.91-1.914 1.91" />
                      <path d="M50.984 79.661l20.776 67.493m-22.195-89.92l28.151 89.779M27.23 79.66L6.453 147.154m22.194-89.92L.497 147.014" />
                      <path d="M44.9563636 70.6057582L49.7781818 80.1566374 52.0472727 79.1661758 49.5654545 57.2345275 52.4018182 52.9896923 25.8109091 52.9896923 28.5763636 57.376022 26.0945455 79.3076703 28.3636364 80.2273846 33.1854545 70.6057582z" />
                      <path d="M39.993 78.812c0 .496-.426.92-.922.92a.938.938 0 0 1-.922-.92c0-.495.426-.92.922-.92.496 0 .922.425.922.92m0 7.712c0 .495-.426.92-.922.92a.938.938 0 0 1-.922-.92c0-.495.426-.92.922-.92.496-.07.922.354.922.92m0 7.64c0 .496-.426.92-.922.92a.938.938 0 0 1-.922-.92c0-.495.426-.92.922-.92.496 0 .922.425.922.92m0 7.712c0 .495-.426.92-.922.92a.938.938 0 0 1-.922-.92c0-.495.426-.92.922-.92.496 0 .922.425.922.92m0 7.711c0 .496-.426.92-.922.92a.938.938 0 0 1-.922-.92c0-.495.426-.92.922-.92.496 0 .922.355.922.92m0 7.641c0 .495-.426.92-.922.92a.938.938 0 0 1-.922-.92c0-.495.426-.92.922-.92.496 0 .922.425.922.92m0 7.712c0 .495-.426.92-.922.92a.938.938 0 0 1-.922-.92c0-.496.426-.92.922-.92.496 0 .922.424.922.92m0 7.711c0 .495-.426.92-.922.92a.938.938 0 0 1-.922-.92c0-.495.426-.92.922-.92.496 0 .922.425.922.92m0 7.712c0 .495-.426.92-.922.92a.938.938 0 0 1-.922-.92c0-.496.426-.92.922-.92.496 0 .922.354.922.92" />
                      <path d="M18.4363636 3.8910989L24.3218182 35.4443736 53.82 35.4443736 59.7054545 3.8910989z" />
                      <g>
                        <path d="M39.284 3.891v31.483M49.849 4.033l-3.404 31.34M28.931 3.892l2.978 31.483M23.4 30.492h31.342M20.776 16.484h36.59" />
                      </g>
                      <path d="M54.67 38.911H23.756c-.922 0-1.631-.707-1.631-1.627v-.212c0-.92.709-1.628 1.63-1.628h30.917c.922 0 1.63.708 1.63 1.628v.212c.072.92-.708 1.627-1.63 1.627m6.24-34.95H17.373A1.754 1.754 0 0 1 15.6 2.194v-.07c0-.991.78-1.77 1.773-1.77H60.91c.993 0 1.773.779 1.773 1.77v.07c-.071.99-.851 1.769-1.773 1.769" />
                    </g>

                    <path
                      className={s.messageBlue}
                      d="M43.646 7H11.42C10.639 7 10 7.638 10 8.417v10.91c0 .78.639 1.418 1.42 1.418h31.09l2.2 2.196c.143.142.285 0 .285-.141V8.417c.07-.78-.568-1.417-1.35-1.417z"
                      fill="#00BED4"
                    />
                    <path
                      className={s.messagePink}
                      d="M113.65 0H74.415C73.637 0 73 .635 73 1.412V22.8c0 .14.212.282.283.14l2.196-2.188h38.1c.778 0 1.416-.635 1.416-1.412V1.411c.07-.776-.567-1.411-1.346-1.411z"
                      fill="#DA46AC"
                    />
                    <path
                      className={s.messageOrange}
                      d="M36.942 59.289c.14-.145 0-.289-.141-.289H1.407C.633 59 0 59.65 0 60.443v11.114C0 72.35.633 73 1.407 73h31.946c.774 0 1.407-.65 1.407-1.443v-9.96l2.182-2.308z"
                      fill="#F35800"
                    />
                    <path
                      className={s.messageGreen}
                      d="M103.588 45h-17.93c-.776 0-1.411.653-1.411 1.45v10.011l-2.189 2.249c-.14.145 0 .29.142.29h21.389c.776 0 1.411-.653 1.411-1.45V46.377c0-.725-.635-1.378-1.412-1.378z"
                      fill="#00BF4A"
                    />
                  </g>
                </svg>

                <div className={s.planes}>
                  <Plane />
                </div>
              </div>
            </div>

            <p className={s.lead}>
              Every year, NATS handles more than 2.5 million flights. Take a
              journey through the skies, learn the language of aviation and see
              how NATS Air Traffic Controllers safely guide a real domestic
              flight from London Heathrow to Manchester.
            </p>

            <div className={s.buttons}>
              {!hasLoaded && (
                <div className={s.loaderWrap}>
                  <span className={s.loader}>
                    <span
                      className={s.bar}
                      style={{
                        transform: `translateZ(0) translateX(${-100 +
                          loadedPercentage}%)`
                      }}
                    />
                    <span className={s.number}>{loadedPercentage}%</span>
                  </span>
                </div>
              )}

              <button
                disabled={!hasLoaded || isHidden}
                className={s.button}
                onClick={hide}
              >
                Get started
              </button>

              <div className={s.mute}>
                <MuteCheckBox disabled={isHidden} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </FocusOn>
  );
};

export default memo(HomeScreen);
